import React from 'react';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import classnames from 'classnames';
import style from './style.module.less';
import sharedStyle from '../style.module.less';

export const LabelBatchLoading = () => {
  return (
    <ModalBody className={classnames(sharedStyle['batch-processing-modal-body'])}>
      <div className={style.loading}>
        <LoadingIndicator theme='grey' />
      </div>
    </ModalBody>
  );
};
